import React from "react";
import { findDOMNode } from "react-dom";
import isEqual from "lodash/isEqual";
import indexOf from "lodash/indexOf";
import WindowFunc from "../../ecology9/wea-tools/window";

import loadjs from "loadjs";

const _const = {
  key: {
    children: "childs",
    checked: "selected"
  }
};

function getNodes(nodes) {
  let arr = [];
  if (!nodes) return arr;
  if (nodes instanceof Array) {
    nodes.forEach(item => {
      arr = arr.concat(getNodes(item));
    });
  } else {
    arr.push(nodes);
    const childs = nodes.subs || nodes.childs || nodes.children;
    if (childs) {
      arr = arr.concat(getNodes(childs));
    }
  }
  return arr;
}

function loadZTree(callback) {
  callback = callback || (() => {});
  loadjs.isDefined("emZTreeV3")
    ? loadjs.ready("emZTreeV3", callback)
    : loadjs(
        [
          window.ecologyContentPath ||
            "" + "/cloudstore/resource/pc/ztree_v3/js/jquery.ztree.all.js",
          window.ecologyContentPath ||
            "" +
              "/cloudstore/resource/pc/ztree_v3/css/zTreeStyle/zTreeStyle.css"
        ],
        "emZTreeV3",
        () => {
          WindowFunc.getTop().document.head.appendChild(
            $(
              `<link rel="stylesheet" type="text/css" href="${window.ecologyContentPath ||
                ""}/cloudstore/resource/pc/ztree_v3/css/zTreeStyle/zTreeStyle.css">`
            )[0]
          );
          callback();
        }
      );
}

export default class TreeZ extends React.Component {
  static loadZTree = loadZTree;
  static defaultProps = {
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    expandedKeys: [],
    checkedKeys: [],
    filterData: []
  };
  constructor(props) {
    super(props);
    this.zTreeOnExpand = this.zTreeOnExpand.bind(this);
    this.zTreeOnCollapse = this.zTreeOnCollapse.bind(this);
    this.zTreeBeforeAsync = this.zTreeBeforeAsync.bind(this);
    this.ajaxDataFilter = this.ajaxDataFilter.bind(this);
    this.updateNode = this.updateNode.bind(this);
    this.addDiyDom = this.addDiyDom.bind(this);
    this.checkedFilter = this.checkedFilter.bind(this);
    this.expandFilter = this.expandFilter.bind(this);
    this.checkableFilter = this.checkableFilter.bind(this);
    this.zTreeOnClick = this.zTreeOnClick.bind(this);
    this.zTreeOnCheck = this.zTreeOnCheck.bind(this);
    this.zTreeAsyncSuccess = this.zTreeAsyncSuccess.bind(this);
    this.isCheckedDisable = this.isCheckedDisable.bind(this);
    this.updateCheckbox = this.updateCheckbox.bind(this);
    this.getKey = this.getKey.bind(this);
    this.ztreeId = this.createHash();
    this.setting = {};
    this.expandedKeys = props.expandedKeys || [];
    this.checkedKeys = props.checkedKeys || [];
    let initData = [];
    this.treeInited = false;
    // if (props.datas && props.datas.length > 0) {
    //   initData = props.datas;
    // }
    if (props.treeData && props.treeData.length > 0) {
      initData = this.props.loadAll
        ? props.treeData
        : this.ajaxDataFilter([], [], { datas: props.treeData });
    }
    this.state = {
      initData: initData
    };
  }
  componentWillReceiveProps(nextProps) {
    // if (this.props.checkStrictly !== nextProps.checkStrictly) {
    //   var treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    //   this.props.loadAll
    //   ? refresh()
    //   : treeObj.reAsyncChildNodes(null, "refresh");
    // }
    // if (
    //   nextProps.datas &&
    //   nextProps.datas.length > 0 &&
    //   !isEqual(nextProps.datas, this.state.initData)
    // ) {
    //   this.setState({ initData: nextProps.datas });
    // }
    if (
      // nextProps.treeData &&
      // nextProps.treeData.length > 0 &&
      !isEqual(nextProps.treeData, this.state.initData)
    ) {
      const initData = this.props.loadAll
        ? nextProps.treeData || []
        : this.ajaxDataFilter([], [], { datas: nextProps.treeData || [] });
      this.setState({ initData });
    }

    if (!isEqual(this.props.asyncOtherParams, nextProps.asyncOtherParams)) {
      this.setting.async.otherParam = nextProps.asyncOtherParams;
    }

    if (this.props.checkStrictly != nextProps.checkStrictly) {
      this.setting.check.chkboxType = nextProps.checkStrictly
        ? { Y: "", N: "" }
        : { Y: "ps", N: "ps" };
      loadjs.ready("emZTreeV3", () => {
        $(document).ready(
          function() {
            $.fn.zTree.init(
              $(findDOMNode(this.refs.ztreeNode)),
              this.setting,
              this.ajaxDataFilter(
                [],
                [],
                { datas: this.state.initData },
                nextProps
              )
            );
            this.updateCheck();
            this.updateExpand();
            this.updateCheckStrictly(nextProps);
            this.treeInited = true;
          }.bind(this)
        );
      });
    }

    if (!isEqual(nextProps.filterData.sort(), this.props.filterData.sort())) {
      this.updateCheckbox(nextProps);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // if (!isEqual(this.props.checkStrictly, prevProps.checkStrictly)) {
    //   let treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    //   // treeObj.refresh();
    //   treeObj.destroy(this.ztreeId);

    //   $.fn.zTree.init(
    //     $(findDOMNode(this.refs.ztreeNode)),
    //     this.setting,
    //     this.props.treeData
    //   );
    // }

    if (!isEqual(this.expandedKeys.sort(), this.props.expandedKeys.sort())) {
      this.expandedKeys = this.props.expandedKeys;
      this.treeInited && this.updateExpand();
    }

    if (!isEqual(this.checkedKeys.sort(), this.props.checkedKeys.sort())) {
      this.checkedKeys = this.props.checkedKeys;
      this.treeInited && this.updateCheck();
    }

    if (
      !isEqual(prevState.initData, this.state.initData)
      // && this.state.initData.length > 0
    ) {
      loadjs.ready("emZTreeV3", this.init);
    }
  }

  updateCheckStrictly(props) {
    const treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    let nodes = treeObj.getNodesByFilter(this.checkStrictlyFilter); // 查找节点集合
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      const nocheck = this.isCheckedDisable(node, props);
      if (nocheck !== node.nocheck) {
        node.nocheck = nocheck;
        node.icon = undefined;
        node.iconSkin = undefined;
        treeObj.updateNode(node, false);
      }
    }
  }

  updateCheckbox(props) {
    const treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    let nodes = treeObj.getNodesByFilter(this.checkableFilter); // 查找节点集合
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      node.nocheck = this.isCheckedDisable(node, props);
      node[_const.key.checked] = !node.nocheck && node[_const.key.checked];
      node.icon = undefined;
      node.iconSkin = undefined;
      treeObj.updateNode(node, false);
    }
  }

  updateCheck() {
    const treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    // 取消未选中的数据
    let nodes = treeObj.getCheckedNodes();
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      if (!this.checkedFilter(node)) {
        treeObj.checkNode(node, false, false, false);
      }
    }
    // 选中需要选中的数据
    nodes = treeObj.getNodesByFilter(this.checkedFilter); // 查找节点集合
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      treeObj.checkNode(node, true, false, false);
    }
  }
  updateExpand() {
    const treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    // let node = treeObj.getNodesByFilter(filter, true); // 仅查找一个节点
    // 收起未展开的节点
    // let nodes = treeObj.getNodesByFilter(e => e.open);
    // for (let index = 0; index < nodes.length; index++) {
    //   const node = nodes[index];
    //   if (!this.expandFilter(node)) {
    //     treeObj.expandNode(node);
    //   }
    // }
    // 展开需要展开的节点
    let nodes = treeObj.getNodesByFilter(this.expandFilter); // 查找节点集合
    // nodes = getNodes(treeObj.getNodes()).filter(this.expandFilter);
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      treeObj.expandNode(node, true, false, false);
    }
  }

  updateSelect() {
    const treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
    // let node = treeObj.getNodesByFilter(filter, true); // 仅查找一个节点
    // let nodes = treeObj.getNodesByFilter(this.expandFilter); // 查找节点集合
    for (let index = 0; index < nodes.length; index++) {
      const node = nodes[index];
      treeObj.expandNode(node, true, false, false);
    }
  }
  updateNode(node) {
    $.fn.zTree.getZTreeObj(this.ztreeId).updateNode(node);
  }
  checkedFilter(node) {
    return this.checkedKeys.some(e => e == node[this.getKey()]);
  }
  expandFilter(node) {
    return this.expandedKeys.some(e => e == node[this.getKey()]);
  }
  checkableFilter(node) {
    const { isHrmTree } = this.props;
    return node.canClick || (isHrmTree && node.type != "com");
  }
  checkStrictlyFilter(node) {
    return node.isParent && node.type != "0";
  }
  createHash() {
    // 默认长度 8
    return Array.from(Array(8), () =>
      Math.floor(Math.random() * 36).toString(36)
    ).join("");
  }
  getKey() {
    return this.props.itemMainKey ? this.props.itemMainKey : "id";
  }
  zTreeOnCollapse(event, treeId, treeNode) {
    // alert(treeNode.tId + ", " + treeNode.name);
    const key = this.getKey();
    if (indexOf(this.expandedKeys, treeNode[key]) > -1) {
      this.expandedKeys.splice(indexOf(this.expandedKeys, treeNode[key]), 1);
      this.props.onExpand &&
        this.props.onExpand(this.expandedKeys, {
          node: treeNode,
          expanded: false
        });
    }
  }
  zTreeOnExpand(event, treeId, treeNode) {
    const key = this.getKey();
    this.expandedKeys.push(treeNode[key]);
    this.props.onExpand &&
      this.props.onExpand(this.expandedKeys, {
        node: treeNode,
        expanded: true
      });
  }
  zTreeBeforeAsync(treeId, treeNode) {
    // return (treeNode.id !== 1);
    if (!treeNode) return false;
    if (this.props.dataUrl) {
      const childs = treeNode.subs || treeNode.childs || treeNode.children;
      if ((childs && childs.length) || treeNode.loadChildNodes) {
        if (childs) {
          const treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
          treeNode.loadChildNodes = true;
          delete treeNode.subs;
          delete treeNode.childs;
          delete treeNode.children;
          delete treeNode.icon;
          delete treeNode.iconSkin;
          treeObj.addNodes(
            treeNode,
            this.ajaxDataFilter([], [], { datas: childs }),
            true
          );
        }
        return false;
      }
      return true;
    } else {
      if (this.props.loadData) {
        // this.props.loadData(treeId, treeNode);
        this.props.loadData({ props: treeNode });
      }
      return false;
    }
  }
  isCheckedDisable(item, props) {
    const {
      multiple,
      filterData,
      inputId,
      inputName,
      checkStrictly,
      isHrmTree
    } = props || this.props;
    if (isHrmTree) {
      if (multiple) {
        if (item.canClick == "false") {
          return true;
        }
        if (filterData && filterData.length) {
          return filterData.some(d => item.id === d.id && item.type === d.type);
        }
        return false;
      } else {
        return true;
      }
    }
    if (multiple) {
      if (!item.canClick && !(!checkStrictly && item.isParent)) {
        return true;
      }
      if (filterData && filterData.length) {
        let id = inputId || "id";
        let name = inputName || "name";
        return filterData.some(
          d =>
            item.id === d[id] &&
            (item.name === d[name] || item.orgWholePathspan === d[name])
        );
      }
      return false;
    } else {
      return !item.canClick || false;
    }
  }
  ajaxDataFilter(treeId, parentNode, responseData, nextProps) {
    if (responseData) {
      if (Array.isArray(responseData.datas)) {
        for (let i = 0; i < responseData.datas.length; i++) {
          responseData.datas[i].nocheck = this.isCheckedDisable(
            responseData.datas[i],
            nextProps
          );
          responseData.datas[i].iconSkin =
            "wea-ztree-icon " + responseData.datas[i].icon;
        }
      } else if (responseData.datas) {
        responseData.datas.nocheck = this.isCheckedDisable(
          responseData.datas,
          nextProps
        );
      }
    }
    return responseData.datas;
  }
  zTreeAsyncSuccess() {
    this.updateCheck();
  }
  // clickFlag	selectedMulti	(autoCancelSelected && event.ctrlKey / metaKey)	isSelected	选中操作
  // 1	true	false	false	普通选中
  // 1	true	false	true	普通选中
  // 2	true	true	false	追加选中
  // 0	true	true	true	取消选中
  // 1	false	false	false	普通选中
  // 1	false	false	true	普通选中
  // 1	false	true	false	普通选中
  // 0	false	true	true	取消选中
  zTreeOnClick(event, treeId, treeNode, clickFlag) {
    if (clickFlag == 1) {
      let treeObj = $.fn.zTree.getZTreeObj(treeId);
      if (this.props.onSelect) {
        let nodes = treeObj.getSelectedNodes();
        let keys = [];
        const key = this.getKey();
        for (let index = 0; index < nodes.length; index++) {
          const element = nodes[index];
          // left tree key setting
          keys.push(element[key]);
        }
        this.props.onSelect(keys, nodes);
      }
    }
  }

  zTreeOnCheck(event, treeId, treeNode) {
    // const { multiple, checkStrictly } = this.props;
    let treeObj = $.fn.zTree.getZTreeObj(treeId);
    const key = this.getKey();
    const nodes = treeObj.getCheckedNodes();
    // if (!multiple) {
    //   treeNode[_const.key.checked] = true;
    //   treeNode.icon = undefined;
    //   treeNode.iconSkin = undefined;
    //   treeObj.updateNode(treeNode, false);
    // }
    treeNode[_const.key.checked]
      ? this.checkedKeys.push(treeNode[key])
      : this.checkedKeys.splice(indexOf(this.checkedKeys, treeNode[key]), 1);
    if (this.props.onCheck) {
      let keys = [];
      for (let index = 0; index < nodes.length; index++) {
        const element = nodes[index];
        // left tree key setting
        keys.push(element[this.getKey()]);
      }
      this.props.onCheck(keys, nodes);
    }
  }

  addHoverDom(treeId, treeNode) {
    // let aObj = $("#" + treeNode.tId + "_a");
    // if ($("#diyBtn_"+treeNode.id).length>0) return;
    // let editStr = "<span id='diyBtn_space_" +treeNode.id+ "' > </span>"
    //   + "<button type='button' class='diyBtn1' id='diyBtn_" + treeNode.id
    //   + "' title='"+treeNode.name+"' onfocus='this.blur();'></button>";
    // aObj.append(editStr);
    // let btn = $("#diyBtn_"+treeNode.id);
    // if (btn) btn.bind("click", function(){alert("diy Button for " + treeNode.name);});
  }
  removeHoverDom(treeId, treeNode) {
    $("#diyBtn_" + treeNode.id)
      .unbind()
      .remove();
    $("#diyBtn_space_" + treeNode.id)
      .unbind()
      .remove();
  }

  addDiyDom(treeId, treeNode) {
    // let aObj = $("#" + treeNode.tId + "_a");
    // if ($("#diyBtn_"+treeNode.id).length>0) return;
    // let editStr = "<span id='diyBtn_space_" +treeNode.id+ "' > </span>"
    //   + "<button type='button' class='diyBtn1' id='diyBtn_" + treeNode.id
    //   + "' title='"+treeNode.name+"' onfocus='this.blur();'></button>";
    // aObj.append(editStr);
    // let btn = $("#diyBtn_"+treeNode.id);
    // if (btn) btn.bind("click", function(){alert("diy Button for " + treeNode.name);});

    const div = document.createElement("div");
    div.className = "ant-tree-title";
    // let liObj = $("#" + treeNode.tId);
    // liObj.append(div);
    let aObj = $("#" + treeNode.tId + "_a");
    aObj.html(div);

    ReactDOM.render(this.props.getTitle(treeNode), div);
  }

  init = () => {
    let initData = this.state.initData;
    $(document).ready(
      function() {
        this.setting = this.setting;
        $.fn.zTree.init(
          $(findDOMNode(this.refs.ztreeNode)),
          this.setting,
          initData
        );
        this.updateExpand();
        this.updateCheck();
        this.treeInited = true;
      }.bind(this)
    );
  };
  componentDidMount() {
    const props = this.props;
    const {
      checkable,
      multiple,
      loadAll,
      dataUrl,
      type,
      keyword,
      getTitle,
      checkStrictly,
      asyncOtherParams = [],
      isHrmTree
    } = props;
    let setting = {
      treeId: this.ztreeId,
      check: {
        enable: checkable,
        chkStyle: multiple ? "checkbox" : "radio",
        radioType: "all",
        chkboxType: checkStrictly ? { Y: "", N: "" } : { Y: "ps", N: "ps" }
      },
      view: {
        showLine: false
      },
      data: {
        key: {
          ..._const.key,
          name: isHrmTree ? "lastname" : "name"
        }
      },
      callback: {
        onExpand: this.zTreeOnExpand,
        onCollapse: this.zTreeOnCollapse,
        beforeAsync: this.zTreeBeforeAsync,
        onAsyncSuccess: this.zTreeAsyncSuccess,
        onClick: this.zTreeOnClick,
        onCheck: this.zTreeOnCheck
      },
      weaProps: {
        ...props
      }
    };

    if (!loadAll) {
      setting.async = {
        enable: true,
        type: "get",
        url: dataUrl,
        autoParam: ["id", "type", "isVirtual", "level"],
        dataFilter: this.ajaxDataFilter,
        otherParam: asyncOtherParams
      };
      let browserType = type;
      let innerParams = { ...asyncOtherParams };
      if (browserType == 4) {
        innerParams.isLoadSubDepartment = 1;
      }
      if (keyword) {
        innerParams.keyword = keyword;
      }
      setting.async.otherParam = innerParams;
    }
    if (getTitle) {
      setting.view.addDiyDom = this.addDiyDom;
    }
    this.setting = setting;
    loadZTree(this.init);
  }

  render() {
    // const props = this.props;
    // let checkable = props.checkable;
    // if (checkable) {
    //   checkable = <span className={`${props.prefixCls}-checkbox-inner`}></span>;
    // }
    return <div className="ztree" ref="ztreeNode" id={this.ztreeId} />;
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/tree-z/index.jsx